var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#EB3000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2192 25.33C16.1706 25.33 15.2282 25.0843 14.3922 24.593C13.5636 24.1017 12.9072 23.4197 12.4232 22.547C11.9392 21.667 11.6972 20.6513 11.6972 19.5V14.902C11.6972 13.6553 11.9392 12.581 12.4232 11.679C12.9072 10.7697 13.5892 10.073 14.4692 9.589C15.3492 9.09767 16.3832 8.852 17.5712 8.852C18.3412 8.852 19.0746 8.96567 19.7712 9.193C20.4679 9.42033 21.1059 9.80533 21.6852 10.348L19.5512 12.482C19.2872 12.218 18.9829 12.0127 18.6382 11.866C18.2936 11.7193 17.9379 11.646 17.5712 11.646C16.9992 11.646 16.5006 11.7817 16.0752 12.053C15.6572 12.317 15.3309 12.6653 15.0962 13.098C14.8689 13.5233 14.7552 13.978 14.7552 14.462V16.816L14.2492 16.266C14.7039 15.804 15.2282 15.452 15.8222 15.21C16.4236 14.9607 17.0432 14.836 17.6812 14.836C18.6786 14.836 19.5549 15.0597 20.3102 15.507C21.0729 15.9543 21.6669 16.5667 22.0922 17.344C22.5249 18.1213 22.7412 19.0087 22.7412 20.006C22.7412 21.0033 22.4882 21.9053 21.9822 22.712C21.4762 23.5113 20.8052 24.1493 19.9692 24.626C19.1332 25.0953 18.2166 25.33 17.2192 25.33ZM17.2192 22.47C17.6739 22.47 18.0882 22.36 18.4622 22.14C18.8436 21.92 19.1442 21.623 19.3642 21.249C19.5916 20.875 19.7052 20.4607 19.7052 20.006C19.7052 19.5513 19.5952 19.137 19.3752 18.763C19.1552 18.3817 18.8582 18.081 18.4842 17.861C18.1102 17.6337 17.6959 17.52 17.2412 17.52C16.7866 17.52 16.3686 17.6337 15.9872 17.861C15.6132 18.081 15.3126 18.3817 15.0852 18.763C14.8652 19.137 14.7552 19.5513 14.7552 20.006C14.7552 20.446 14.8652 20.853 15.0852 21.227C15.3052 21.601 15.6022 21.9017 15.9762 22.129C16.3502 22.3563 16.7646 22.47 17.2192 22.47Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 34.0033C14.534 29.7134 8.25 31.392 8.25 35.6074C8.25 40.3449 14.7727 42.0236 16.9601 46.4254L16.9999 46.5L17.0397 46.4254C19.2272 42.0236 25.7498 40.3449 25.7498 35.6074C25.7896 31.392 19.4658 29.7134 16.9999 34.0033Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9998 50.0059C32.5612 42.2841 21.25 45.3057 21.25 52.8932C21.25 61.4208 32.9908 64.4424 36.9282 72.3657L36.9998 72.5L37.0714 72.3657C41.0089 64.4424 52.7497 61.4208 52.7497 52.8932C52.8213 45.3057 41.4384 42.2841 36.9998 50.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6H);
export default __webpack_public_path__ + "static/media/6h.27bc0e769e2c328ea189bca5f036b6d6.svg";
export { ForwardRef as ReactComponent };